import { Button } from '@toggle/design-system';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useNavigateToAssetOverview } from '~/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';

import { CompanyCatalystWidget } from '../../company-catalyst-widget/CompanyCatalystWidget';
import * as S from './CompanyCatalystDrawer.styles';

export const CompanyCatalystDrawer = () => {
  const { t } = useTranslation(['insights']);
  const { navigateToPage } = useNavigateToAssetOverview();
  const { trackCatalystDrawerOpen } = usePosthogEvents();

  const { closeDrawer, isOpen, drawerType, entityTag, insightId, utmSource } =
    useCatalystDrawer();

  useEffect(() => {
    if (isOpen && utmSource === POSTHOG_TRACKING_SOURCES.EMAIL) {
      trackCatalystDrawerOpen(utmSource, 'company');
    }
  }, [isOpen, utmSource, drawerType]);

  const handleHeaderButtonClick = () => {
    if (entityTag) {
      navigateToPage({
        entityTag: entityTag,
      });
    }
  };

  if (!insightId || !entityTag) {
    return null;
  }

  return (
    <S.StyledDrawer
      data-testid="catalyst-drawer"
      isOpen={isOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        <Button
          variant="empty"
          label={t('insights:catalyst.viewOnAO')}
          iconName="Expand"
          size="xsmall"
          onClick={handleHeaderButtonClick}
        />
      }
    >
      <S.ContentWrapper>
        <ErrorBoundaryWrapper>
          <CompanyCatalystWidget insightId={insightId} />
        </ErrorBoundaryWrapper>
      </S.ContentWrapper>
    </S.StyledDrawer>
  );
};
